import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Customer } from '../../models/customer/customer-model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';


 

@Injectable()
export class CustomerService {

  private serviceName = 'api/customer';
  private utilityService = "api/Utility";
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }

  addCustomer(customerModel: Customer): void {
    this.http
      .post(`${this.serviceName}`, customerModel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/customers"]);
      });
  }
  updateCustomer(customerModel: Customer) {
    //Todo
    return this.http.put(`${this.serviceName}`, customerModel, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  ForgotPassword(email: string) { 
    return this.http.get(`${this.serviceName}/ForgotPasswordAsync?email=` + email, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  UpdateCustomerData(id: string, customerModel: Customer) {
    //Todo
    return this.http.put(`${this.serviceName}/UpdateCustomer/` + id, customerModel, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteCustomer(id: string) {
    return this.http.delete(`${this.serviceName}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getCustomer() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GetVendorsList() {
    return this.http.get(`${this.serviceName}/GetAllVendorsList`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetCustomerGrid(pageNumber: number, pageSize: number, statusFilter: string, searchKeyword: string) {
    return this.http.get(`${this.serviceName}/GetCustomerGrid?pageNumber=` + pageNumber + `&pageSize=` + pageSize + `&statusFilter=` + statusFilter + `&searchKeyword=` + searchKeyword , {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetVendorGrid(pageNumber: number, pageSize: number, statusFilter: string, searchKeyword: string) {
    return this.http.get(`${this.serviceName}/GetVendorGrid?pageNumber=` + pageNumber + `&pageSize=` + pageSize + `&statusFilter=` + statusFilter + `&searchKeyword=` + searchKeyword, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  
  UpdateCustomerStatusBulk(CustomerList: any, StatusId: any) {
    return this.http.post(`${this.serviceName}/UpdateCustomerStatusBulk?statusId=` + StatusId, CustomerList, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GetCustomerStatus() {
    return this.http.get(`${this.utilityService}/GetCustomerStatus`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getVendors() {
    return this.http.get(`${this.serviceName}/GetVendorsList`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getVendorsDropDown() {
    return this.http.get(`${this.serviceName}/GetVendorsDropDownList`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getActiveVendors() {
    return this.http.get(`${this.serviceName}/GetActiveVendorsList`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getVendorsList() { 
    return this.http.get(`${this.serviceName}/GetVendorsList`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getVendorsDropDownList() {

    return this.http.get(`${this.serviceName}/GetVendorsDropDownList`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getCUstomer(id: string) { 
    return this.http.get(`${this.serviceName}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  toggleStatus(id: string) {
    return this.http.put(`${this.serviceName}/` + id, null, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  isUniqueShopName(shopName: string, customerId: number) {
    if (customerId == undefined) customerId = 0;
    return this.http
      .get(`${this.serviceName}/IsUniqueShopName?shopName=` + shopName + `&customerId=` + customerId, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  UpdateCustomerFullName() {
    return this.http
      .get(`${this.serviceName}/UpdateCustomerFullName`, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
  static toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }


  public exportAsExcelFile(json: any[], excelFileName: string): void {  
    //const aux = json.map(el => ({ Name: el.fullName, EmailAddress: el.email }));
    //const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(aux);
    //const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    
    //XLSX.writeFile(workbook, CustomerService.toExportFileName(excelFileName));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/customer/customer.service.ts